export const ticketLinkTypes = {
  GENERAL_ONSALE: 1,
  GENERAL_ONSALE_ADA: 2,
  PRE_SALE: 3,
  PRE_SALE_ADA: 4,
  SEPARATE_PROMOTION: 5,
};



// WEBPACK FOOTER //
// ./src/common/constants/ticketLinkTypes.js